<template>
    <aside class="tile tile-blur">
        <h3 class="font-title text-xl">{{ data.title }}</h3>
        <ul>
            <li
                v-if="price"
                class="flex justify-between border-b border-white/20 py-4 last-of-type:border-none">
                <span>{{ t('interventionDetail.price') }}</span>
                <span class="font-semibold">{{ price }}</span>
            </li>
            <li
                v-for="item in data.features"
                :key="item.label"
                class="flex justify-between border-b border-white/20 py-4 last-of-type:border-none">
                <span>{{ item.label }}</span> <span class="font-semibold">{{ item.value }}</span>
            </li>
        </ul>
        <slot />
    </aside>
</template>

<script setup lang="ts">
import type { InterventionFeatures } from '@su4r-frontend/api';

defineProps<{
    price?: string;
    data: InterventionFeatures;
}>();

const { t } = useI18n();
</script>
